<template>
    <div class="bottombar">
        <div @click="onMark" class="button">
            <Icon type="ios-list-box-outline" />
        </div>
        <div @click="$emit('input', 1)" class="button">
            <Icon type="ios-skip-backward-outline" />
        </div>
        <div @click="$emit('input', Math.max(1, value - step))" class="button">
            <Icon type="md-arrow-back" />
        </div>
        <div class="index">
            <label @focus="onFocus" ref="label" tabindex="1">{{value}}/{{max}}</label>
            <input @blur="onBlur" @input="onInput" :value="value" type="number" autocomplete="off" ref="input"/>
        </div>
        <div @click="$emit('input', Math.min(max, value + step))" class="button">
            <Icon type="md-arrow-forward" />
        </div>
        <div @click="$emit('input', max)" class="button">
            <Icon type="ios-skip-forward-outline" />
        </div>
        <div @click="onAuto" class="button" :class="{ active: autoId != null }">
            <Icon type="ios-images-outline" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            autoId: null,
        };
    },
    props: {
        value: {
            default: 1
        },
        max: {
            default: 1
        },
        step: {
            default: 1
        },
        marked: {
            default: false,
        }
    },
    methods: {
        onInput(e) {
            let result = e.target.value || 1;
            this.$emit('input', Math.min(this.max, result));
        },
        onFocus() {
            this.$refs.label.style.display = 'none';
            this.$refs.input.focus();
        },
        onBlur() {
            this.$refs.label.style.display = 'block';
        },
        onAuto() {
            if (null === this.autoId) {
                this.autoId = setInterval(() => {
                    let v = (this.value % this.max) + 1;
                    this.$emit('input', v);
                }, 5000);
            } else {
                clearInterval(this.autoId);
                this.autoId = null;
            }
        },
        onMark() {
            this.$emit('mark', !this.marked);
        }
    }
}
</script>

<style lang="less" scoped>
.bottombar {
    @height: 35px;
    @font-size: 25px;

    position: relative;
    height: @height;
    z-index: 2000;
    text-align: center;
    font-size: @font-size;

    .button {
        display: inline-block;
        box-sizing: content-box;
        width: @height;
        height: @height;
        vertical-align: middle;
        margin: 0 .125em;
        color: white;
        background: transparent;

        &:hover, &:active, &.active {
            background-color: rgba(255, 255, 255, 0.25);
            border-bottom: 2px solid white;
        }
    }
    .index {
        position: relative;
        display: inline-block;
        width: 5em;
        height: @height;
        font-size: @font-size * 0.5;
        vertical-align: middle;

        label {
            position: absolute;
            top: 0.5em;
            left: 0;
            right: 0;
            bottom: 0.5em;
            z-index: 2;
            margin: 0 .125em;
            text-align: center;
            vertical-align: middle;
            line-height: @font-size;
            background-color: white;
        }

        input {
            position: absolute;
            box-sizing: border-box;
            top: 0.5em;
            left: 0;
            bottom: 0.5em;
            width: 100%;
            z-index: 1;
            text-align: center;
            border: none;
            background-color: white;
            opacity: 0;

            &:focus {
                opacity: 1;
            }
        }
    }
}
</style>
